<div class="card">
    <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
        <div><h4><strong style="font-size: large; margin-left:10px">Vendor Details</strong></h4></div>
        <button pButton type="button" icon="pi pi-download" (click)="downloadExcel()" style="height:10px; margin-right: 10px; background-color:#2c436b" label="Report"></button>    
    </div>
    <hr>
        <p-table [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="5"
        [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '100rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[5, 10, 20]">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="business_name">Name <p-sortIcon field="business_name"></p-sortIcon></th>
                <th pSortableColumn="vendor_code">Vendor Code <p-sortIcon field="vendor_code"></p-sortIcon></th>
                <th pSortableColumn="primary_address">Primary Address <p-sortIcon field="primary_address"></p-sortIcon></th>
                <!-- <th pSortableColumn="vendor_group">Vendor Group <p-sortIcon field="vendor_group"></p-sortIcon></th> -->
                <th pSortableColumn="city">City <p-sortIcon field="city"></p-sortIcon></th>
                <th pSortableColumn="state">State <p-sortIcon field="state"></p-sortIcon></th>
                <th pSortableColumn="country">Country <p-sortIcon field="country"></p-sortIcon></th>
                <th pSortableColumn="gstin">GSTIN Number <p-sortIcon field="gstin"></p-sortIcon></th>
            </tr>
            <tr>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="business_name" 
                        placeholder="Search" 
                        ariaLabel="Filter Name" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="vendor_code" 
                        placeholder="Search" 
                        ariaLabel="Filter Vendor Code" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="primary_address" 
                        placeholder="Search" 
                        ariaLabel="Filter Primary Address" />
                </th>
                <!-- <th>
                    <p-columnFilter 
                        type="text"
                        field="vendor_group" 
                        placeholder="Search by Vendor Group" 
                        ariaLabel="Filter Vendor Group" />
                </th> -->
                <th>
                    <p-columnFilter 
                        type="text"
                        field="city" 
                        placeholder="Search" 
                        ariaLabel="Filter City" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="state" 
                        placeholder="Search" 
                        ariaLabel="Filter State" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="country" 
                        placeholder="Search" 
                        ariaLabel="Filter Country" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text"
                        field="gstin" 
                        placeholder="Search" 
                        ariaLabel="Filter GSTIN" />
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendor>
            <tr>
                <td>
                    <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.vendor_code,vendor.status)" class="p-button-rounded" pTooltip="View Details"></button>
                </td>
                <td>{{ vendor.business_name }}</td>
                <td>{{ vendor.vendor_code }}</td>
                <td>{{ vendor.address_details.address_title }}</td>
                <!-- <td>{{ vendor.vendor_group }}</td> -->
                <td>{{vendor.address_details.city}}</td>
                <td>{{vendor.address_details.state}}</td>
                <td>{{vendor.address_details.country}}</td>
                <td>{{vendor.address_details.tax_details.gstn}}</td>
                
            </tr>
        </ng-template>
    </p-table>
</div>
